/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Stock Status Dynamic Update
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var stockStatusElements = document.querySelectorAll('.stock-status');
  
  stockStatusElements.forEach(function(stockStatus) {
    var indicator = stockStatus.querySelector('.stock-status__indicator');
    var icon = stockStatus.querySelector('.stock-status__icon circle');
    var text = stockStatus.querySelector('.stock-status__text');
    
    if (variant && variant.available) {
      // Update for in stock
      indicator.className = 'stock-status__indicator stock-status__indicator--in-stock';
      icon.setAttribute('fill', '#4ade80');
      text.textContent = text.getAttribute('data-in-stock-text') || 'Auf Lager';
    } else {
      // Update for incoming/out of stock
      indicator.className = 'stock-status__indicator stock-status__indicator--incoming';
      icon.setAttribute('fill', '#fbbf24');
      text.textContent = text.getAttribute('data-incoming-text') || 'Im Zulauf';
    }
  });
});

